import React from 'react';
import _ from 'lodash';
import { getHost } from 'util/api';

const FlagCell = ({data, column, meet, style}) => {
  const lifter = data;
  if(lifter.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else {
    const country = _.toLower(_.get(lifter, 'country'));
    const host = getHost();
    const imgStyle = {};

    if(country) {
      imgStyle.height = '100%';
      imgStyle.width = '100%';
      imgStyle.backgroundImage = `url('${host}/flags/${country}.svg')`;
      imgStyle.backgroundSize = 'contain';
      imgStyle.backgroundRepeat = 'no-repeat';
      imgStyle.backgroundPosition = 'top left';
    }

    return (
      <div style={style} className="table-cell-inner">
        { country && <div style={imgStyle} /> }
      </div>
    );
  }
};

export default FlagCell;
